export const currencyUnitsGlobal = [
    { id: 0, unit: 'Units', value: 1},
    { id: 1, unit: 'Thousand', value: 1000 },
    { id: 2, unit: 'Lakh' , value: 100000},
    { id: 3, unit: 'Crore', value: 10000000},
]